import {
    getLifechallengeCategoryUrl1,
    getLifechallengeCategoryUrl2,
    getLifechallengeCategoryUrl3,
    getLifechallengeCategoryUrl4, getLifechallengeCategoryUrl5, getLifechallengeCategoryUrl6
} from "../getCategoryData/getCategoryData";

declare let nomineeMainpage;

export const isNomineeMainpage = () => {
    if (typeof nomineeMainpage != "undefined")
        return nomineeMainpage;
    return false;
};

declare let nomineeCategoryId;

export const getNomineeCategoryId = () => {
    if (typeof nomineeCategoryId != "undefined")
        return nomineeCategoryId;
    return -1;
};



declare let nomineeItems;

export const getNomineeItems = () => {
    if (typeof nomineeItems != "undefined")
        return nomineeItems;
    return [];
};


declare let winnerItems;

export const getWinnerItems = () => {
    if (typeof winnerItems != "undefined")
        return winnerItems;
    return null;
};
declare let enableWinnerCarousel;

export const getEnableWinnerCarousel = () => {
    if (typeof enableWinnerCarousel != "undefined")
        return enableWinnerCarousel;
    return false;
};


declare let lifechallenge_nominee_base_url;

export const getNomineeBaseUrl = () => {
    if (typeof lifechallenge_nominee_base_url != "undefined")
        return lifechallenge_nominee_base_url;
    return "";
};

export const getNomineeCategoryData = () => {
    let categoriesData: { id: number, image: string, title: string, url: string }[] = [
        {
            id: 1,
            image: "/files/com/lifechallenge/categories/single-family-1.jpg",
            title: "lifechallenge_category_single",
            url: getNomineeBaseUrl()+"/"+getLifechallengeCategoryUrl1()
        },
        {
            id: 2,
            image: "/files/com/lifechallenge/categories/multi-residential-1.jpg",
            title: "lifechallenge_category_multi",
            url: getNomineeBaseUrl()+"/"+getLifechallengeCategoryUrl2()
        },
        {
            id: 3,
            image: "/files/com/lifechallenge/categories/non-residential-2.jpg",
            title: "lifechallenge_category_non_residental",
            url: getNomineeBaseUrl()+"/"+getLifechallengeCategoryUrl3()
        },
        {
            id: 4,
            image: "/files/com/lifechallenge/categories/thermal-renovation-1.jpg",
            title: "lifechallenge_category_thermal",
            url: getNomineeBaseUrl()+"/"+getLifechallengeCategoryUrl4()
        },
        {
            id: 5,
            image: "/files/com/lifechallenge/categories/historical-renovation1.jpg",
            title: "lifechallenge_category_historical",
            url: getNomineeBaseUrl()+"/"+getLifechallengeCategoryUrl5()
        },
        {
            id: 6,
            image: "/files/com/lifechallenge/categories/texture1.jpg",
            title: "lifechallenge_category_sbtexture",
            url: getNomineeBaseUrl()+"/"+getLifechallengeCategoryUrl6()
        },
    ];

    return categoriesData;
};




